import { CwtApiEntity, CwtModel, CwtProp } from "@cawita/core-front/api";
import { ProConfig } from "./pro-config.model";

@CwtModel({ name: 'setting' })
export class Setting extends CwtApiEntity {
    @CwtProp({ ref: ProConfig }) proConfig: ProConfig;
}